import RestaurantModel from '../DataModels/Restaurant';
import { actionManager } from './BaseFunction';
// ///////////////
// Reducers
// ///////////////
const restaurantDM = new RestaurantModel();
const Restaurants = (state = restaurantDM, action) => actionManager(state, action, 'restaurants');

export default Restaurants;
